export default __webpack_public_path__ + "02284644406bf5494f5f954d402af0a8.svg";